import {productFlagsActionTypes} from "../constants/ActionTypes";

const initialState = {
  flag: [],
  conditions: {},
  params: {},
  locales: {}
};

const flags = (state = initialState, action) => {

  switch (action.type) {
    case productFlagsActionTypes.GET_PRODUCT_FLAG:
      return {
        ...state,
        flag: action.flag,
      };
    case productFlagsActionTypes.GET_PRODUCT_FLAG_OPTIONS:
      return {
        ...state,
        conditions: action.conditions,
        paramsData: action.paramsData,
        locales: action.locales
      };
  }

  return state;
};

export default flags;



// WEBPACK FOOTER //
// ./reducers/flags.reducers.js